import styles from "./ResendEmail.module.scss";
import { useEffect, useRef } from "react";
import Button from "../button/Button";
import { urlConstants } from "../../constants/urlConstants";
import { constants } from "../../constants/constants";
import { useDispatch } from "react-redux";
import { updateIsLoading } from "../../../reducerSlices/loaderSlice";

const ResendEmail = ({
  setCloseResendEmail,
  setToastData,
  order_number,
}: {
  setCloseResendEmail: React.Dispatch<React.SetStateAction<boolean>>;
  setToastData: React.Dispatch<React.SetStateAction<any>>;
  toastData: {
    message: string;
    status: string;
  };
  order_number: string;
}) => {
  const resendEmailRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        resendEmailRef &&
        resendEmailRef.current &&
        !resendEmailRef?.current?.contains(event.target)
      ) {
        setCloseResendEmail(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  async function handleResendEmail(type: "both" | "buyer" | "supplier") {
    try {
      dispatch(updateIsLoading(true));
      const response = await fetch(
        `${urlConstants.BASE_URL}store/master-order/resend-mail/${order_number}?send_for=${type}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.ok) {
        setToastData({
          message: "Email resent successfully",
          status: "success",
        });
      } else {
        setToastData({
          message: "Failed to resend email",
          status: "fail",
        });
      }
    } catch (error) {
      console.error("Error resending email:", error);
      setToastData({
        message: "An error occurred while resending the email",
        status: "fail",
      });
    } finally {
      dispatch(updateIsLoading(false));
      setTimeout(() => {
        setToastData(constants.defaultToastData);
      }, 3000);
      setCloseResendEmail(false);
    }
  }

  return (
    <>
      <section className={styles.parentContainer} ref={resendEmailRef}>
        <header>
          <div className={styles.heading} style={{ textAlign: "center" }}>
            Resend Placement Email
          </div>
        </header>
        <main
          className={styles.mainContainer}
          style={{ display: "flex", flexDirection: "row", gap: "1rem" }}
        >
          <Button
            label={"Both"}
            secondary
            handleClick={() => handleResendEmail("both")}
          ></Button>
          <Button
            label={"Buyer"}
            secondary
            handleClick={() => handleResendEmail("buyer")}
          ></Button>
          <Button
            label={"Supplier"}
            secondary
            handleClick={() => handleResendEmail("supplier")}
          ></Button>
        </main>
      </section>
    </>
  );
};

export default ResendEmail;
